import VueGtag from 'vue-gtag-next'
import { getCookieConsentByCategory } from '~/utils/cookie-script'
import { COOKIE_SCRIPT_CATEGORIES } from '~/constants/cookie-script.constant'

export default defineNuxtPlugin({
  name: 'google-analytics',
  dependsOn: ['cookies'],
  setup(nuxtApp) {
    const { $config, vueApp } = nuxtApp

    const acceptTargetingCookies = getCookieConsentByCategory({
      category: COOKIE_SCRIPT_CATEGORIES.PERFORMANCE,
    })

    vueApp.use(VueGtag, {
      isEnabled: $config.public.isProduction && acceptTargetingCookies.value,
      property: {
        id: $config.public.googleAnalyticsKey,
      },
    })
  },
})
